/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pie } from '@ant-design/plots';
import IconEmpty from '../../assets/Images/icons/empty';
import { Spin } from 'antd';

export default function Dashboard1({ dataRisk, isLoading }) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const [riskInfo, setRiskInfo] = useState([]);

    useEffect(() => {
        if (dataRisk) {
            setRiskInfo(
                [
                    {
                        type: t('DashBoardRM.RiskActivities'),
                        value: dataRisk.riskActivities,
                        total: dataRisk.totalRiskActivity,
                    },
                    {
                        type: t('DashBoardRM.ActivitiesWithoutRisk'),
                        value: dataRisk.noRiskActivities,
                        total: dataRisk.totalRiskActivity,
                    },
                ].reverse()
            );
        }
    }, [dataRisk, lang]);

    const config = useMemo(() => {
        return {
            data: riskInfo,
            angleField: 'value',
            colorField: 'type',
            color: ({ type }) => {
                switch (type) {
                    case t('DashBoardRM.RiskActivities'):
                        return '#F0536F';
                    default:
                        return '#FFEBEE';
                }
            },
            radius: 1,
            width: 280,
            height: 280,
            innerRadius: 0.6,
            label: false,
            legend: false,
            interactions: [
                {
                    type: 'element-active',
                },
            ],
            statistic: {
                title: true,
                content: {
                    content: t('DashBoardRM.RiskActivities'),
                    style: {
                        fontSize: 14,
                        color: '#505D6F',
                    },
                },
            },
        };
    }, [riskInfo]);

    return (
        <Spin spinning={isLoading}>
            <div className="font-semibold text-xl">
                {t('DashBoardRM.RiskActivitiesWithinTheOrganization')}
            </div>
            {dataRisk?.totalRiskActivity ? (
                <div className="grid grid-cols-5 flex items-center">
                    <div
                        className="col-span-3 mt-4"
                        style={{ minHeight: '280px', maxHeight: '280px' }}
                    >
                        <Pie {...config} />
                    </div>
                    <div className="col-span-2">
                        <div className="grid grid-cols-3 py-2">
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#F0536F"
                                    />
                                </svg>
                                <div className="pl-2">
                                    {t('DashBoardRM.RiskActivities')}
                                </div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.riskActivities} (
                                {(
                                    (dataRisk.riskActivities /
                                        dataRisk.totalRiskActivity) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>
                        <div
                            className="grid grid-cols-3 pt-2 pb-6"
                            style={{ borderBottom: '0.5px solid #E9EBF1' }}
                        >
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#FFEBEE"
                                    />
                                </svg>
                                <div className="pl-2">
                                    {t('DashBoardRM.ActivitiesWithoutRisk')}
                                </div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.noRiskActivities} (
                                {(
                                    (dataRisk.noRiskActivities /
                                        dataRisk.totalRiskActivity) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>

                        <div className="grid grid-cols-3 pt-6">
                            <div className="col-span-2">
                                <div className="font-bold">{t('Total')}</div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.totalRiskActivity} (100%)
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="h-[30vh] flex justify-center items-center">
                    <IconEmpty />
                </div>
            )}
        </Spin>
    );
}
